/**
 * @export
 * @class RefundBanners
 * 배송정보 안내 배너
 */
export default class RefundBanners {
  constructor() {
    // 필요 data 유효 확인
    const {
      bIsDeliveryDeal,
      htDealContentInfo: { bannerViewInfo },
    } = TMON.oApp.htStorage.htStaticData;
    if (
      bIsDeliveryDeal ||
      !bannerViewInfo ||
      bannerViewInfo.hideUnusedRefundInfo ||
      (!bannerViewInfo.hideUnusedRefundRate &&
        bannerViewInfo.hideUnusedRefundRate !== 0)
    ) {
      return;
    }

    this.welWrapper = $('#_refundBanners');

    this.render();
  }

  render() {
    const {
      // bIsTourDeal,
      htDealContentInfo: {
        bannerViewInfo: { hideUnusedRefundRate },
      },
    } = TMON.oApp.htStorage.htStaticData;

    const sHtml = `
            ${
              hideUnusedRefundRate === 0
                ? `<div class="ct_wrp item">
                        <strong class="tit_bn ico_ticket_no">미사용 티켓<br>환불제 미적용</strong>
                        <div class="txt_area">
                            <p>유효기간 <strong>종료일</strong>까지 사용해주세요.</p>
                            <p class="desc">유효기간 내에 사용하지 못한 티켓은 환불되지 않습니다.</p>
                        </div>
                    </div>`
                : `<div class="ct_wrp item">
                        <strong class="tit_bn ico_ticket">미사용 티켓<br>환불제 적용</strong>
                        <div class="txt_area">
                            <p>유효기간 내 사용하지 못한 티켓은 <strong>구매 금액의 ${hideUnusedRefundRate}%</strong> 를 티몬캐시/적립금으로 지급해드립니다.</p>
                            <p class="info">지급 수단 : 결제 형태에 따라 상이(티몬캐시 1년, 적립금 180일 사용 가능)<br/>지급 일자 : 유효기간 종료 +6영업일 후</p>
                        </div>
                    </div>`
            }

        `;

    this.welWrapper.html(sHtml);
  }
}
